import React from "react";
import { AwardIcon, ClipboardListIcon, FileSearchIcon, GiftIcon, HeartHandshakeIcon, RulerIcon, BoxIcon } from "lucide-react";
type Bonus = {
  icon: BoxIcon;
  title: string;
  value: string;
  description: string;
  imageUrl: string;
};
const bonuses: Bonus[] = [{
  icon: FileSearchIcon,
  title: "The Coach's Scriptbook",
  value: '$25 Value',
  description: 'A practical library of coaching language, instructions, and session cues to lead every practice with clarity.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/qNeKxSX3W3ZEuGLAGujZjg/3d98a92b-a095-489a-9078-cd070011d7ee-mockup.webp'
}, {
  icon: ClipboardListIcon,
  title: 'Warm-Up & Agility Library',
  value: '$15 Value',
  description: 'High-energy warm-ups and agility progressions to get every player switched on from the first whistle.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/ruYH2PTqNXJysFKWwos9dq/e385c657-c7bd-4ee4-b180-db64560ffda8-mockup.webp'
}, {
  icon: AwardIcon,
  title: 'The Goalscoring Blueprint',
  value: '$20 Value',
  description: 'Build better circle entries, sharper finishing habits, and a repeatable system for creating goals.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/iLYEMA6TtLiMTobCpKtEEX/f60244a0-c7fe-4948-a326-cd486e668122-mockup.webp'
}, {
  icon: HeartHandshakeIcon,
  title: 'Game-Day Management Pro',
  value: '$12 Value',
  description: 'Keep your team composed with clear pre-match routines, tactical reminders, and sideline decisions.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/e2kX1W7t5KoDemzoasoDkk/e01d7199-e4bb-489b-9f02-25e02b7e881a-mockup.webp'
}, {
  icon: RulerIcon,
  title: 'Performance Testing Tracker',
  value: '$15 Value',
  description: 'Measure speed, agility, and technical growth with a simple tracker built for hockey development.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/kJj4dntmS95CMWt3emvMNv/d4b9f50a-7dc1-458a-abef-42e6435de29c-mockup.webp'
}];
export function BonusSection() {
  return <section className="bg-[#1a2633] px-5 py-20" data-id="element-3" data-mp="3h7hkmwlny3yp">
      <div className="mx-auto max-w-5xl" data-id="element-4" data-mp="1h2cbjhb596pq">
        <div className="text-center" data-id="element-5" data-mp="1h5hzuuby84ke">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-6" data-mp="1c4u0nldkghf3">
            <GiftIcon className="h-4 w-4" data-id="element-7" data-mp="1q3248c53ygz8" /> Included FREE today
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-8" data-mp="1m1yqbv6mev0n">
            Five strategic <span className="text-emerald-300" data-id="element-9" data-mp="ydp6uzwvqjco">bonuses</span>
          </h2>
          <p className="mt-4 text-sm font-medium text-slate-300" data-id="element-10" data-mp="teciubu9v68i">
            Total bonus value: $87 — included free today with HOCKEY READY™.
          </p>
        </div>

        <div className="mt-11 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-11" data-mp="12eivjvi5c26m">
          {bonuses.map(({
          icon: Icon,
          title,
          value,
          description,
          imageUrl
        }, index) => <article key={title} className="overflow-hidden border border-emerald-200/20 bg-[#2a3847]" data-id="element-12" data-mp="anl4evvfgpn9" data-mpi={index}>
              <img src={imageUrl} alt={`Mockup of the ${title} bonus`} width={1024} height={1024} loading="lazy" className="mx-auto mt-5 aspect-square w-[84%] object-cover" data-id="element-13" data-mp="jo81nn8y4zl" />
              <div className="p-6" data-id="element-14" data-mp="5bxv8vwz8qy6">
                <div className="flex items-center justify-between gap-4" data-id="element-15" data-mp="3mre1v0el7lsz">
                  <span className="grid h-11 w-11 place-items-center border border-emerald-300/40 bg-emerald-400/10" data-id="element-16" data-mp="3rppe1hscu8ed">
                    <Icon className="h-5 w-5 text-emerald-300" data-id="element-17" data-mp="j9cqih9wvsy2" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-18" data-mp="o8p92ptr2duu">
                    Bonus {String(index + 1).padStart(2, '0')}
                  </p>
                </div>
                <div className="mt-6" data-id="element-19" data-mp="eajc8mmsvxwu">
                  <span className="border border-emerald-300/40 px-2 py-1 text-[10px] font-bold uppercase text-emerald-200" data-id="element-20" data-mp="e9i0sh1vh9el">
                    {value} — Free today
                  </span>
                  <h3 className="mt-4 text-lg font-bold text-white" data-id="element-21" data-mp="2z1ti4fam0kin">{title}</h3>
                  <p className="mt-2 text-sm font-medium leading-relaxed text-slate-300" data-id="element-22" data-mp="3f8esivhk0qto">{description}</p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}